export default __webpack_public_path__ + "static/media/kindness.7decd17c.webp";